import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-75e03bec")

_pushScopeId("data-v-75e03bec")
const _hoisted_1 = { class: "reel-scene-editor mt-3 mb-3" }
const _hoisted_2 = { class: "d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-0" }, "Video scenes", -1)
const _hoisted_4 = { class: "text-muted fs-8" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-8 mb-3" }, " Edit on-screen captions and video scenery before generating your video. Use English keywords for background clips. Timing may adjust slightly to match your voiceover. ", -1)
const _hoisted_6 = { class: "reel-scene-editor__header mb-2" }
const _hoisted_7 = { class: "fw-semibold fs-7" }
const _hoisted_8 = { class: "text-muted fs-8" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-1" }, "On-screen caption", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-1" }, "Video scenery", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-9 mb-2" }, " English keywords for background clips (e.g. team meeting wellness lifestyle). ", -1)
const _hoisted_12 = {
  key: 0,
  class: "text-muted fs-8 mb-2"
}
const _hoisted_13 = {
  key: 1,
  class: "text-danger fs-8 mb-2"
}
const _hoisted_14 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-1" }, "Background clip options", -1)
const _hoisted_16 = { class: "reel-scene-editor__preview-grid" }
const _hoisted_17 = { class: "reel-scene-editor__preview-media" }
const _hoisted_18 = {
  key: 1,
  class: "reel-scene-editor__preview-placeholder"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fas fa-film text-muted" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "fas fa-play" }, null, -1)
const _hoisted_21 = { class: "reel-scene-editor__preview-label" }
const _hoisted_22 = {
  key: 0,
  class: "reel-scene-editor__attribution text-muted mb-1 mt-1"
}
const _hoisted_23 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_24 = {
  key: 0,
  class: "text-muted fs-9"
}
const _hoisted_25 = {
  key: 1,
  class: "text-muted fs-8 mb-2"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-1" }, "Scene length (sec)", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.scenes.length) + " scene" + _toDisplayString(_ctx.scenes.length === 1 ? "" : "s") + " · ~" + _toDisplayString(_ctx.totalDurationSec) + "s planned ", 1)
    ]),
    _hoisted_5,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scenes, (scene, index) => {
      return (_openBlock(), _createBlock("div", {
        key: _ctx.sceneKey(scene, index),
        class: "reel-scene-editor__card mb-3"
      }, [
        _createVNode("div", _hoisted_6, [
          _createVNode("span", _hoisted_7, " Scene " + _toDisplayString(index + 1) + " · " + _toDisplayString(_ctx.sceneTypeLabel(scene.imageKey)), 1),
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.formatDuration(scene.durationSec)) + "s", 1)
        ]),
        _hoisted_9,
        _createVNode("textarea", {
          class: "form-control form-control-sm mb-2",
          rows: "2",
          value: scene.text || '',
          disabled: _ctx.disabled,
          placeholder: "Short caption shown on screen",
          onInput: ($event: any) => (_ctx.onCaptionInput(index, ($event.target as _ctx.HTMLTextAreaElement).value))
        }, null, 40, ["value", "disabled", "onInput"]),
        (_ctx.sceneryEditable(scene))
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _hoisted_10,
              _createVNode("input", {
                type: "text",
                class: "form-control form-control-sm mb-1",
                value: scene.stockQuery || '',
                disabled: _ctx.disabled,
                placeholder: "English keywords, 2–8 words",
                onInput: ($event: any) => (_ctx.onSceneryInput(index, ($event.target as _ctx.HTMLInputElement).value)),
                onBlur: ($event: any) => (_ctx.normalizeSceneryField(index))
              }, null, 40, ["value", "disabled", "onInput", "onBlur"]),
              _hoisted_11,
              (_ctx.previewState(index).loading)
                ? (_openBlock(), _createBlock("div", _hoisted_12, " Loading background options… "))
                : (_ctx.previewState(index).error)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(_ctx.previewState(index).error), 1))
                  : (_ctx.previewState(index).options.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode("div", _hoisted_16, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.previewState(index).options, (option, optionIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              key: option.optionId,
                              class: ["reel-scene-editor__preview-tile", {
                'reel-scene-editor__preview-tile--selected': _ctx.isOptionSelected(scene, option.optionId),
                'reel-scene-editor__preview-tile--disabled': _ctx.disabled
              }],
                              role: "button",
                              tabindex: "0",
                              onClick: ($event: any) => (_ctx.selectPreviewOption(index, option.optionId)),
                              onKeydown: [
                                _withKeys(_withModifiers(($event: any) => (_ctx.selectPreviewOption(index, option.optionId)), ["prevent"]), ["enter"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.selectPreviewOption(index, option.optionId)), ["prevent"]), ["space"])
                              ]
                            }, [
                              _createVNode("div", _hoisted_17, [
                                (option.previewUrl)
                                  ? (_openBlock(), _createBlock("img", {
                                      key: 0,
                                      src: option.previewUrl,
                                      alt: "",
                                      loading: "lazy"
                                    }, null, 8, ["src"]))
                                  : (_openBlock(), _createBlock("div", _hoisted_18, [
                                      _hoisted_19
                                    ])),
                                _createVNode("button", {
                                  type: "button",
                                  class: "reel-scene-editor__preview-play",
                                  disabled: _ctx.disabled || !option.pageUrl,
                                  "aria-label": `Preview option ${optionIndex + 1} clip`,
                                  onClick: _withModifiers(($event: any) => (_ctx.openPreviewPage(option.pageUrl)), ["stop"])
                                }, [
                                  _hoisted_20
                                ], 8, ["disabled", "aria-label", "onClick"])
                              ]),
                              _createVNode("span", _hoisted_21, "Option " + _toDisplayString(optionIndex + 1), 1)
                            ], 42, ["onClick", "onKeydown"]))
                          }), 128))
                        ]),
                        (_ctx.providerAttribution(_ctx.previewState(index).provider))
                          ? (_openBlock(), _createBlock("p", _hoisted_22, [
                              _createTextVNode(_toDisplayString(_ctx.providerAttribution(_ctx.previewState(index).provider)?.prefix) + " ", 1),
                              _createVNode("a", {
                                href: _ctx.providerAttribution(_ctx.previewState(index).provider)?.href,
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }, _toDisplayString(_ctx.providerAttribution(_ctx.previewState(index).provider)?.label), 9, ["href"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_23, [
                          _createVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-light",
                            disabled: _ctx.disabled || _ctx.previewState(index).loading || _ctx.previewState(index).refreshRemaining <= 0,
                            onClick: ($event: any) => (_ctx.refreshPreview(index))
                          }, " Show more options ", 8, ["disabled", "onClick"]),
                          (_ctx.previewState(index).refreshRemaining <= 0)
                            ? (_openBlock(), _createBlock("span", _hoisted_24, " Try different scenery keywords for more variety. "))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createBlock("div", _hoisted_25, _toDisplayString(_ctx.sceneryLockedHint(scene)), 1)),
        _hoisted_26,
        _createVNode("input", {
          type: "number",
          class: "form-control form-control-sm reel-scene-editor__duration",
          value: scene.durationSec,
          min: "2",
          max: "8",
          step: "0.5",
          disabled: _ctx.disabled,
          onInput: ($event: any) => (_ctx.updateSceneField(index, 'durationSec', ($event.target as _ctx.HTMLInputElement).value)),
          onBlur: ($event: any) => (_ctx.clampDurationField(index))
        }, null, 40, ["value", "disabled", "onInput", "onBlur"])
      ]))
    }), 128))
  ]))
})